import { animate, state, style, transition, trigger } from '@angular/animations';

export const modalOpenAndLeave = trigger('slideInOut', [
  state('void', style({ transform: 'translateX(100%)' })),
  state('open', style({ transform: 'translateX(0)' })),
  state('closed', style({ transform: 'translateX(100%)' })),
  transition('void => open', [animate('500ms cubic-bezier(.43,-0.33,.53,1.22)')]),
  transition('open => closed', [animate('500ms cubic-bezier(.43,-0.33,.53,1.22)')]),
]);
